import { render, staticRenderFns } from "./CommentTopBarIcon.vue?vue&type=template&id=3ef15808&"
import script from "./CommentTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./CommentTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports